import {isEmpty} from "@/util/Helpers";

const getDefaultState = () => {
    return {
        isAuthenticated: false,
        csCookie: null,
        authProfile: null
    }
}

export const namespaced = true
export const state = getDefaultState()

export const mutations = {
    SET_COOKIES(state, data) {
        state.csCookie = data.cookies.csCookie

    },
    SET_AUTH(state, data) {
        state.authProfile = data.auth
        state.isAuthenticated = data.isAuthenticated
    },
    RESET_STATE(state) {
        Object.assign(state, getDefaultState())
    },
}
export const actions = {
    updateCookies({commit}, cookies) {
        commit('SET_COOKIES', cookies)
    },
    updateAuth({commit}, data) {
        commit('SET_AUTH', data)
    },
    resetState({commit}) {
        commit('RESET_STATE')
    },
}

export const getters = {
    isAuthenticated(state) {
        return !isEmpty(state.authProfile[0]?.t002Id) && state.isAuthenticated
    },

    getProfile(state) {
        return !isEmpty(state.authProfile) ? state.authProfile[0] : null
    },
    getCsCookies: (state) => {
        return state.csCookie
    },
}

